import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
import { TabLayoutDataItem } from '../../../../constants';
import { ConstructionSales } from './ConstructionSales';
import { TabModel } from '../../../../models';
import { TabMonthTemplate } from './tabs/TabMonth.template';
import { TabFiveYearTemplate } from './tabs/TabFiveYear.template';

/**
 * 화면 > 탭
 * @window w_tb_e471w_04
 * @category 공사수주매출통계
 */
export const ConstructionSalesTab: Array<TabLayoutDataItem<ConstructionSales>> = [
  {
    tab: new TabModel('Five', FaQuoteLeft, '10년간 수주매출내역'),
    template: (scope) => <TabFiveYearTemplate scope={scope} />,
  },
  {
    tab: new TabModel('Month', FaQuoteRight, '월별 수주매출내역'),
    template: (scope) => <TabMonthTemplate scope={scope} />,
  },
];
